var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-subtitle',{class:_vm.customClass,attrs:{"data-cy":_vm.dataCy}},[_c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.tooltipText},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_c('span',[_vm._v(" "+_vm._s(_vm.label)+": ")]),_c('span',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.formattedText)+" ")])])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }